module.exports = __webpack_public_path__ + "images/d2f6856cbf507dfbb73e66ef32245731-profile_overlay.jpg";